import React, { useContext } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import {
  Box,
  Button,
  ButtonBase,
  Container,
  Grid,
  Hidden,
  Link,
  Typography,
  useTheme,
} from "@mui/material";
import Hero from "../../components/layout/Hero";
import {
  BCPSearch,
  BCPArrowRightFromBracket,
  BCPCheck,
  BCPArrowUpFromBracket,
  BCPUser,
  BCPUserGroup,
  BCPEnvelope,
} from "../../components/icons/bcp/BCPIcons";
import HighlightedEvents from "../../components/utilities/HighlightedEvents";
import FeaturedEvents from "../../components/utilities/FeaturedEvents";
import PostGallery from "../../components/utilities/PostGallery";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import EventsPreview from "../../components/utilities/EventsPreview";
import FollowedOrganizations from "../../components/utilities/FollowedOrganizations";
import SponsorsBar from "../../components/utilities/SponsorsBar";
import { findGetParameter } from "../../components/utilities/UtilityFunctions";
const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);
const SUPPORTS_CMS = findGetParameter("SUPPORTS_CMS") === "true";
const getAppLinks = () => {
  let appLinks = {};
  if (
    getEnvironmentVariable("APP_LINKS") !== undefined &&
    getEnvironmentVariable("APP_LINKS") !== "NOT SET"
  ) {
    try {
      appLinks = JSON.parse(getEnvironmentVariable("APP_LINKS"));
    } catch (err) {}
  }
  return appLinks;
};

const forArray = ["players", "game stores", "tournament organizers", "you"];

export default function HomeBCPProd() {
  const authContext = useContext(AuthContext);

  const isLoggedIn = authContext?.authState?.isAuthenticated;
  const isSubscribed = authContext?.authState?.identity?.subscriber;

  const theme = useTheme();
  const mode = theme.palette.mode;

  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Hero
          backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/header.jpg`}
          sxBackground={{
            height: ["auto", "60vh"],
            maxHeight: ["400px", "600px"],
            minHeight: "350px",
            color: "common.white"
          }}
        />
        <Grid
          container
          spacing={2}
          sx={{
            maxWidth: "lg",
            p: 4,
            zIndex: 1,
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
                gap: 2,
                color: mode === "dark" ? "text.primary" : "common.white",
              }}
            >
              <Box
                sx={{
                  display: ["flex", "block"],
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Hidden mdDown>
                  <img
                    src={`${getEnvironmentVariable(
                      "SYSTEM_IMAGES_CLOUDFRONT"
                    )}/images/BannerLogoDarkLarge.png`}
                    alt="logo"
                    style={{
                      maxHeight: "160px",
                    }}
                  />
                </Hidden>
                <Hidden mdUp>
                  <img
                    src={`${getEnvironmentVariable(
                      "SYSTEM_IMAGES_CLOUDFRONT"
                    )}/images/BannerLogoDarkLarge.png`}
                    alt="logo"
                    style={{
                      maxHeight: "90px",
                    }}
                  />
                </Hidden>
              </Box>

              <Typography
                variant="h3"
                gutterBottom
                sx={{ fontWeight: 700, mb: 2 }}
              >
                {`The world's leading platform for competitive game organizing`}
              </Typography>

              {forArray.map((text) => (
                <Typography
                  variant="body1"
                  key={text}
                  sx={{
                    fontWeight: 700,
                    mt: -1,
                    display: "flex",
                    justifyContent: "center",
                    gap: 1,
                    fontSize: "18px",
                  }}
                >
                  <BCPCheck /> For {text}
                </Typography>
              ))}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "center", gap: 2 }}
              >
                {!isLoggedIn ? (
                  <Button
                    href="/login"
                    variant="contained"
                    color="secondary"
                    startIcon={<BCPArrowRightFromBracket />}
                  >
                    Login
                  </Button>
                ) : (
                  <Button
                    focusRipple
                    href="/subscription"
                    variant="contained"
                    color="success"
                  >
                    Subscribe
                  </Button>
                )}

                <Button
                  href="/play/events"
                  variant="contained"
                  color="primary"
                  startIcon={<BCPSearch />}
                >
                  Find an Event
                </Button>
              </Grid>
              {(getAppLinks().player?.apple ||
                getAppLinks()?.player?.google) && (
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center", gap: 2 }}
                >
                  {getAppLinks()?.player?.apple && (
                    <ButtonBase
                      focusRipple
                      style={{
                        width: "150px",
                      }}
                      href={getAppLinks().player.apple}
                      target="_blank"
                      aria-label={`View app in Apple App Store.`}
                    >
                      <span
                        style={{
                          width: "150px",
                          height: "44px",
                          backgroundSize: "150px 44px",
                          backgroundRepeat: "no-repeat",
                          backgroundImage: `url(${SYSTEM_IMAGES_CLOUDFRONT}/system-images/apple.png)`,
                        }}
                      />
                    </ButtonBase>
                  )}
                  {getAppLinks().player?.google && (
                    <ButtonBase
                      focusRipple
                      style={{
                        width: "150px",
                      }}
                      href={getAppLinks().player.google}
                      target="_blank"
                      aria-label={`View app in Google Play Store.`}
                    >
                      <span
                        style={{
                          width: "150px",
                          height: "44px",
                          backgroundSize: "150px 44px",
                          backgroundRepeat: "no-repeat",
                          backgroundImage: `url(${SYSTEM_IMAGES_CLOUDFRONT}/system-images/google.png)`,
                        }}
                      />
                    </ButtonBase>
                  )}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <FeaturedEvents
        title="Event Spotlight"
        titleProps={{
          sx: { fontWeight: 700, mt: 2 },
          variant: "h3",
        }}
        containerSx={{ p: 1 }}
      />

      {!isLoggedIn && <HighlightedEvents />}

      <SponsorsBar
        imageProps={{ style: { height: "120px" } }}
        titleProps={{
          sx: { fontWeight: 700, mt: 2 },
          variant: "h3",
        }}
      />

      {SUPPORTS_CMS && (
        <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
          <Grid container spacing={1} sx={{ mb: 2 }}>
            <Grid item xs={12}>
              <Typography variant="h3" sx={{ fontWeight: 700 }} gutterBottom>
                News
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ p: 1 }}>
              <PostGallery
                searchLimit={6}
                doPaging={false}
                loadMoreHref="/news"
              />
            </Grid>
          </Grid>
        </Container>
      )}

      {!isLoggedIn ? (
        <>
          <Hero
            backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/section1.jpg`}
            sxBackground={{
              height: ["unset", "70vh"],
              maxHeight: ["unset", "700px"],
              minHeight: "unset",
              color: "common.white",
            }}
            maxWidth="md"
          >
            <Grid container sx={{ p: 1 }}>
              <Grid item xs={12} md={6} lg={4} />

              <Grid item xs={12} md={6} lg={8}>
                <Typography variant="h1" align="left" color="inherit" paragraph>
                  For Players
                </Typography>
                <Typography
                  variant="body1"
                  align="left"
                  color="inherit"
                  paragraph
                >
                  {`The Best Coast Pairings player app for iOS and Android is a player's connection to competitive events. Using the Player App you can search for, browse through and register for events. Also, see table assignments and pairings and view placings for any ongoing events. Players who are participating in the event can securely check in and remotely score as well as see any submitted lists at the event.`}
                </Typography>
                <Typography
                  variant="body1"
                  align="left"
                  color="inherit"
                  paragraph
                >
                  <Link
                    href={isSubscribed ? "/account" : "/subscription/player"}
                    underline="none"
                  >
                    Subscribe
                  </Link>{" "}
                  {`and see any submitted list, deck or crew for any event world wide and get exclusive discounts and rewards.`}
                </Typography>

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: ["center", "flex-start"],
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  {!isSubscribed || !isLoggedIn ? (
                    <>
                      {!isLoggedIn && (
                        <Button
                          variant="contained"
                          color="primary"
                          href="/login?page=signup"
                          startIcon={<BCPUser />}
                        >
                          Sign Up
                        </Button>
                      )}

                      {!isSubscribed && (
                        <Button
                          variant="outlined"
                          color="primary"
                          href="/subscription"
                          startIcon={<BCPArrowUpFromBracket />}
                        >
                          Subscribe to Upgrade
                        </Button>
                      )}
                    </>
                  ) : (
                    <>
                      {getAppLinks().player?.apple && (
                        <ButtonBase
                          focusRipple
                          style={{
                            width: "150px",
                          }}
                          href={getAppLinks().player.apple}
                          target="_blank"
                          aria-label={`View app in Apple App Store.`}
                        >
                          <span
                            style={{
                              width: "150px",
                              height: "44px",
                              backgroundSize: "150px 44px",
                              backgroundRepeat: "no-repeat",
                              backgroundImage: `url(${SYSTEM_IMAGES_CLOUDFRONT}/system-images/apple.png)`,
                            }}
                          />
                        </ButtonBase>
                      )}
                      {getAppLinks().player?.google && (
                        <ButtonBase
                          focusRipple
                          style={{
                            width: "150px",
                          }}
                          href={getAppLinks().player.google}
                          target="_blank"
                          aria-label={`View app in Google Play Store.`}
                        >
                          <span
                            style={{
                              width: "150px",
                              height: "44px",
                              backgroundSize: "150px 44px",
                              backgroundRepeat: "no-repeat",
                              backgroundImage: `url(${SYSTEM_IMAGES_CLOUDFRONT}/system-images/google.png)`,
                            }}
                          />
                        </ButtonBase>
                      )}
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Hero>
          <Hero
            backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/section2.jpg`}
            sxBackground={{
              height: ["unset", "70vh"],
              maxHeight: ["unset", "700px"],
              minHeight: "unset",
              color: "common.white",
            }}
            maxWidth="md"
          >
            <Grid container sx={{ p: 1 }}>
              <Grid item xs={12} md={6} lg={8}>
                <Typography variant="h1" align="left" color="inherit" paragraph>
                  For Tournament Organizers
                </Typography>
                <Typography
                  variant="body1"
                  align="left"
                  color="inherit"
                  paragraph
                >
                  {`The Best Coast Pairings Tournament Organizer for iOS (testing for Android) is the easiest way to run your gaming event. Currently, the TO App offers support for over 15 of your favorite game systems such as Warhammer 40k, Xwing and Magic. This free software provides a TO with everything they need to run their event easily including: online registration, pairings, placings and rankings. Even opt for online ticket sales for a small charge per ticket. This revolutionary tool makes it easy to be a TO for any system giving you more time to judge and have fun.`}
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: ["center", "flex-start"],
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    href="/organize/organization"
                    startIcon={<BCPUserGroup />}
                  >
                    Create An Organization
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Hero>
          <Hero
            backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/section3.jpg`}
            sxBackground={{
              height: ["unset", "70vh"],
              maxHeight: ["unset", "700px"],
              minHeight: "unset",
              color: "common.white",
            }}
            maxWidth="md"
          >
            <Grid container sx={{ p: 1 }}>
              <Grid item xs={12} md={6} lg={4} />

              <Grid item xs={12} md={6} lg={8}>
                <Typography variant="h1" align="left" color="inherit" paragraph>
                  For Retailers, Conventions {"&"} League Organizers
                </Typography>
                <Typography
                  variant="body1"
                  align="left"
                  color="inherit"
                  paragraph
                >
                  {`Event Suite by Best Coast Pairings is the ultimate tool to run your large multi game events, leagues and retail events. Create and manage custom leagues and rankings for your location and administer which TOs can create events. Administrators can use one payment account for multiple TOs and discounted ticketing fees. Additionally event suite provides a location website or iframe support for your own site to display your leagues and rankings. For more information contact`}{" "}
                  <Link
                    href="mailto:support@bestcoastpairings.com"
                    color="inherit"
                  >
                    support@bestcoastpairings.com
                  </Link>
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: ["center", "flex-start"],
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    href="/support"
                    startIcon={<BCPEnvelope />}
                  >
                    Contact Us
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Hero>
        </>
      ) : (
        <Box sx={{ width: "100%" }}>
          <Container sx={{ p: 1, mb: 2 }} maxWidth="lg">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <EventsPreview />
              </Grid>

              <Grid item xs={12}>
                <FollowedOrganizations />
              </Grid>
            </Grid>
          </Container>
        </Box>
      )}
    </Box>
  );
}
